import {Component, OnInit} from '@angular/core';
import {Observable} from 'rxjs';
import * as fromReducer from './qschecks-controlling-filter.reducer';
import {ModalController, NavController} from '@ionic/angular';
import * as actionsUi from './qschecks-controlling-filter.actions.ui';
import {select, Store} from '@ngrx/store';
import {Pruefplan, SaisonIdGruppe, SaisonIdTypId, Quartal} from '../../../../clients/qschecks';
import {getFunktionsbereichePruefplaene, getFunktionsbereichePruefplaeneFehler, getFunktionsbereichePruefplaeneLaden, getPrueferrollenListe, getPruefplanSelected, getFilterOptionsFehler, getFilterOptionsLaden, getSaisonUndQuartalListe} from './qschecks-controlling-filter.selectors';
import {ListInputItem} from '../../../shared/sopi-list/sopi-list.model';
import {QsFilter} from './qschecks-controlling-filter.model';
import {UebersichtFilterType} from '../qschecks-controlling-home/qs-checks-controlling-home.model';
import {take, filter} from 'rxjs/operators';
@Component({
    selector: 'app-qschecks-controlling-filter',
    templateUrl: './qschecks-controlling-filter.page.html'
})
export class QschecksControllingFilterPage implements OnInit {
    aiName = 'QschecksControllingFilterPage';
    fbPruefplaeneListe$: Observable<Array<ListInputItem>>;
    fbPruefplaeneListeLaden$: Observable<boolean>;
    fbPruefplaeneListeFehler$: Observable<boolean>;
    pruefplanSelected$: Observable<Pruefplan>;
    prueferRollenListe$: Observable<Array<ListInputItem>>;
    saisonQuartalListe$: Observable<Array<ListInputItem>>;
    saisonQuartalOptionsLaden$: Observable<boolean>;
    saisonQuartalOptionsFehler$: Observable<boolean>;
    public rollenIds: Array<string> = [];
    public saison: SaisonIdGruppe = null;
    public saisonId: SaisonIdTypId = null;
    public quartal: Quartal = null;
    public filterType: UebersichtFilterType = UebersichtFilterType.SAISONS;

    get selectedSaisonOderQuartalId(): string {
        if (this.saison) {
            return this.saison.titel;
        } else if (this.quartal) {
            return `Q${this.quartal.q}/${this.quartal.jahr}`;
        }
        return null;
    }

    constructor(public navCtrl: NavController,
                private modalCtrl: ModalController,
                private store: Store<fromReducer.PageState>) {
    }
    ngOnInit() {
        this.fbPruefplaeneListe$ = this.store.pipe(select(getFunktionsbereichePruefplaene()));
        this.fbPruefplaeneListeLaden$ = this.store.pipe(select(getFunktionsbereichePruefplaeneLaden()));
        this.fbPruefplaeneListeFehler$ = this.store.pipe(select(getFunktionsbereichePruefplaeneFehler()));
        this.pruefplanSelected$ = this.store.pipe(select(getPruefplanSelected()));
        this.prueferRollenListe$ = this.store.pipe(select(getPrueferrollenListe()));
        this.saisonQuartalListe$ = this.store.pipe(select(getSaisonUndQuartalListe()));
        this.saisonQuartalOptionsLaden$ = this.store.pipe(select(getFilterOptionsLaden()));
        this.saisonQuartalOptionsFehler$ = this.store.pipe(select(getFilterOptionsFehler()));
    }
    ionViewWillEnter() {
        this.viewWillEnterPage().then();
        const localData = JSON.parse(localStorage.getItem('qsFilterPruefplan'));
        if (localData !== null && localData !== undefined && localData !== '') {
            this.filterType = localData.filterType ?? UebersichtFilterType.SAISONS;

            // Unterstützung für altes und neues Format
            if (localData.saison) {
                // Altes Format mit SaisonIdGruppe
                this.saison = localData.saison;
                this.saisonId = localData.saison.saison_id_liste?.[0];
            } else if (localData.saisonIds && localData.saisonIds.length > 0) {
                // Neues Format - Saison aus Liste finden
                this.saisonId = localData.saisonIds[0];

                // Warte auf Liste und finde die passende Saison
                this.saisonQuartalListe$.pipe(
                    filter(liste => liste !== null && liste !== undefined && liste.length > 0),
                    take(1)
                ).subscribe(liste => {
                    const gefundeneSaison = liste.find(item => {
                        if (item.item?.type === 'saison') {
                            const saison = item.item.data as SaisonIdGruppe;
                            return saison?.saison_id_liste?.some(id =>
                                id?.saison_id === this.saisonId?.saison_id &&
                                id?.typ_id === this.saisonId?.typ_id
                            );
                        }
                        return false;
                    });
                    if (gefundeneSaison) {
                        this.saison = gefundeneSaison.item.data as SaisonIdGruppe;
                    }
                });
            } else if (localData.quartal) {
                // Quartal wiederherstellen
                this.quartal = localData.quartal;

                // Warte auf Liste und finde das passende Quartal
                this.saisonQuartalListe$.pipe(
                    filter(liste => liste !== null && liste !== undefined && liste.length > 0),
                    take(1)
                ).subscribe(liste => {
                    const gefundenesQuartal = liste.find(item => {
                        if (item.item?.type === 'quartal') {
                            const quartal = item.item.data as Quartal;
                            return quartal?.jahr === this.quartal?.jahr &&
                                   quartal?.q === this.quartal?.q;
                        }
                        return false;
                    });
                    if (gefundenesQuartal) {
                        this.quartal = gefundenesQuartal.item.data as Quartal;
                    }
                });
            }

            this.store.dispatch(new actionsUi.AktuellePruefplanIdSetzenAction(localData.pruefplanId));
            setTimeout(() => {
                this.rollenIds = localData.rollenIds || [];
            }, 500);
        }
    }
    async viewWillEnterPage() {
        await this.store.dispatch(new actionsUi.PageStateResetAction());
    }
    async ok(pruefplan: Pruefplan) {
        const data: QsFilter = {
            pruefplanId: pruefplan.pruefplan_id,
            saisonIds: this.saison?.saison_id_liste,
            quartal: this.quartal,
            rollenIds: this.rollenIds,
            filterType: this.filterType
        };
        localStorage.setItem('qsFilterPruefplan', JSON.stringify(data));
        await this.modalCtrl.dismiss(data);
    }

    get isOkDisabled(): boolean {
        return this.rollenIds?.length === 0 ||
               (this.saison === null && this.quartal === null);
    }
    async abbrechen() {
        await this.modalCtrl.dismiss();
    }
    pruefplanAuswaehlen(pruefplan: Pruefplan) {
        this.saison = null;
        this.saisonId = null;
        this.quartal = null;
        this.rollenIds = [];
        this.store.dispatch(new actionsUi.AktuellenPruefplanSetzenAction(pruefplan));
    }
    fbPruefplaeneLaden() {
        this.store.dispatch(new actionsUi.FunktionsbereichPruefplaeneLadenAction());
    }
    filterOptionsLaden() {
        // Lädt Prüferrollen und Saisons/Quartale neu, falls ein Prüfplan ausgewählt ist
        this.pruefplanSelected$.pipe(take(1)).subscribe(pruefplan => {
            if (pruefplan && pruefplan.pruefplan_id) {
                this.store.dispatch(new actionsUi.AktuellenPruefplanSetzenAction(pruefplan));
            }
        });
    }
    rollenAuswaehlen($event) {
        this.saison = null;
        this.saisonId = null;
        this.quartal = null;
        this.rollenIds = $event;
    }
    saisonAuswaehlen($event: any) {
        if ($event && $event.type === 'saison') {
            this.saison = $event.data;
            this.quartal = null;
            this.filterType = UebersichtFilterType.SAISONS;
        } else if ($event && $event.type === 'quartal') {
            this.quartal = $event.data;
            this.saison = null;
            this.filterType = UebersichtFilterType.QUARTALE;
        }
    }
}
